export default __webpack_public_path__ + "assets/audio/ssml/sub.9fc48ca59dd661319a84ee80437267c9.mp3";